import { render, staticRenderFns } from "./deliveryInfo.vue?vue&type=template&id=dd8b6b32&scoped=true&"
import script from "./deliveryInfo.vue?vue&type=script&lang=js&"
export * from "./deliveryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8b6b32",
  null
  
)

export default component.exports